export default __webpack_public_path__ + "static/media/Johnson Controls.b0e2a4fa.png";